<template>
  <div class="flex items-center space-x-2 lg:space-x-4">
    <BaseButton
      color="primary"
      :label="btnText"
      :class="btnClass"
      :size="btnSize"
      shadow
      :loading="loading"
      :disabled="disabled"
      @click="selectTutorClicked"
      @mouseleave="$emit('mouseLeave')"
      @mouseover="$emit('mouserOver')"
    />
  </div>
</template>

<script>

import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'CommonTutorSelectAction',
  props: {
    btnClass: {
      type: String,
      default: ''
    },
    btnText: {
      type: String,
      default: ''
    },
    btnSize: {
      type: String,
      default: 'sm-lg'
    },
    teacher: {
      type: Object,
      default: () => {
      }
    },
    isActiveBtn: {
      type: Boolean,
      default: false
    },
    needDisabled: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      loading: false
    }
  },
  computed: {
    ...mapGetters('teacher', ['getTutorSelect']),
    ...mapGetters('course', ['getCourseId', 'getTypeSelected']),
    disabled () {
      if (!this.needDisabled) {
        return false
      } else {
        return !this.isActiveBtn
      }
    }
  },
  created () {
  },
  methods: {
    ...mapActions('teacher', ['fetchTutorSelect']),
    ...mapActions('authentication', ['saveActionAfterLogin']),
    async selectTutorClicked () {
      if (!this.$auth.loggedIn) {
        const id = this.teacher.id
        const url = this.localePath({
          name: this.$routes.tutor_request_form.name,
          query: {
            teacher_id: id,
            course_id: this.getTypeSelected === 'SIBLINGS' ? this.getCourseId : null
          }
        })
        this.$auth.$storage.setLocalStorage('oauth_redirect_url', url)
        await this.saveActionAfterLogin({
          type: 'redirect-query',
          target: this.$routes.tutor_request_form.name,
          query: {
            teacher_id: id,
            course_id: this.getTypeSelected === 'SIBLINGS' ? this.getCourseId : null
          }
        })
        this.$nuxt.$emit('AuthDialogLogin')
      } else {
        await this.$emit('bookingClicked')
      }
    }
  }
}
</script>

<style scoped>

</style>
